export const homeBtnMoneyHandler = {
  homeBtnMoneyHandler_deposit: "存款",
  homeBtnMoneyHandler_withdraw: "提现",
  homeBtnMoneyHandler_transfer: "转账",

  homeBtnMoneyHandler_balance: "账户余额",
};
